<template>
    <div>
        <app-tabela
            idTabela="tblManutencoes"
            :itens="contrato.manutencoes"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :bordered="false"
            :small="false"
        >
            <template slot="botoes">
                <div class="d-flex flex-row-reverse mb-3">
                    <btn-inserir
                        :contrato="contrato"
                        @obterManutencoesAtualizadas="obterManutencoes()"
                    ></btn-inserir>
                </div>
            </template>
            <template slot="status" slot-scope="data">
                <app-status
                    :status="data.status == 1 ?  'SIM' : 'NÃO'"
                ></app-status>
            </template>
            <template slot="acoes" slot-scope="data">
                <btn-atualizar
                    :contrato="contrato"
                    :manutencao="data"
                    :idManutencaoContrato="data.idManutencaoContrato"
                    @obterManutencoesAtualizadas="obterManutencoes()"
                ></btn-atualizar>
                <btn-excluir
                    :contrato="contrato"
                    :manutencao="data"
                    :idManutencaoContrato="data.idManutencaoContrato"
                    @obterManutencoesAtualizadas="obterManutencoes()"
                ></btn-excluir>
                <btn-ativar-desativar-item-manutencao
                    :contrato="contrato"
                    :manutencao="data"
                    :idManutencaoContrato="data.idManutencaoContrato"
                    @obterManutencoesAtualizadas="obterManutencoes()"
                ></btn-ativar-desativar-item-manutencao>
            </template>
        </app-tabela>
    </div>
</template>

<script>
import ManutencaoServicos from './ManutencoesContratosServicos'
import BtnInserir from './BtnInserirManutencao'
import BtnAtualizar from './BtnAtualizarManutencao'
import BtnExcluir from './BtnExcluirManutencao'
import BtnAtivarDesativarItemManutencao from './BtnAtivarDesativarItemManutencao'

export default {
    components: {
        BtnInserir,
        BtnAtualizar,
        BtnExcluir,
        BtnAtivarDesativarItemManutencao,
    },
    props: {
        contrato: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            itensManutencoes: [],
            campos: [
                {
                    key: 'descricao',
                    label: 'Descrição',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'dataInicio',
                    label: 'Data Inicial',
                    sortable: true,
                    type: 'date',
                },
                {
                    key: 'dataFim',
                    label: 'Data Final',
                    sortable: true,
                    type: 'date',
                },
                {
                    key: 'status',
                    label: 'Concluída',
                    sortable: true,
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 5
        }
    },
    methods: {
        obterManutencoes() {
            this.$store.dispatch('addRequest')
            ManutencaoServicos.obterManutencoes(
                this.$route.params.contratoId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.$emit('atualizarManutencoes', response.data)
                    } else {
                        this.$toast.error(
                            'Erro ao obter as manutenções',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },
    
    created() {},

    computed: {},

    watch: {}
}
</script>
